<template>
  <div class="about">
    <h1>This is an about page</h1>
  </div>
</template>

<script>
export default {
  created() {
    console.log("the key is", this.$route.query.key);
  }
};
</script>
